import React from "react";
import "./SharedStyles.scss";

const EAFullScreenLoader: React.FC = () => {
  return (
    <div className="fullscreen-loader-container">
      <img src={"https://eaktywni.pl/wp-content/uploads/2024/05/Animation-1716582172685.gif"} alt="loader" />
    </div>
  );
};

export default EAFullScreenLoader;
